import * as SingleSelect from '@givebutter/primitives/single-select';

const EmptyOperatorOptions = () => (
    <>
        <SingleSelect.Item value="is_empty">
            <SingleSelect.ItemText>Is empty</SingleSelect.ItemText>
        </SingleSelect.Item>
        <SingleSelect.Item value="is_not_empty">
            <SingleSelect.ItemText>Is not empty</SingleSelect.ItemText>
        </SingleSelect.Item>
    </>
);

export { EmptyOperatorOptions };
